import { combineLatest, map, of, switchMap } from 'rxjs';
import { memo } from '../util/index.js';
function getPrev(api) {
  return api.query.society.candidates().pipe(switchMap(candidates => combineLatest([of(candidates), api.query.society['suspendedCandidates'].multi(candidates.map(_ref => {
    let {
      who
    } = _ref;
    return who;
  }))])), map(_ref2 => {
    let [candidates, suspended] = _ref2;
    return candidates.map((_ref3, index) => {
      let {
        kind,
        value,
        who
      } = _ref3;
      return {
        accountId: who,
        isSuspended: suspended[index].isSome,
        kind,
        value
      };
    });
  }));
}
function getCurr(api) {
  return api.query.society.candidates.entries().pipe(map(entries => entries.filter(_ref4 => {
    let [, opt] = _ref4;
    return opt.isSome;
  }).map(_ref5 => {
    let [{
      args: [accountId]
    }, opt] = _ref5;
    return [accountId, opt.unwrap()];
  })
  // FIXME We are missing the new fields from the candidate record
  .map(_ref6 => {
    let [accountId, {
      bid,
      kind
    }] = _ref6;
    return {
      accountId,
      isSuspended: false,
      kind,
      value: bid
    };
  })));
}
/**
 * @description Get the candidate info for a society
 */
export function candidates(instanceId, api) {
  return memo(instanceId, () => api.query.society['suspendedCandidates'] && api.query.society.candidates.creator.meta.type.isPlain ? getPrev(api) : getCurr(api));
}